import type { FeatureRoute } from '../types';
import { ActivationCodesPage } from './ActivationCodesPage';

/** Screens of this feature (A2). */
export const routes: FeatureRoute[] = [
  { path: 'activation-codes', element: <ActivationCodesPage /> },
];
